var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactivenotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_3762",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.635742,
    y: 0.104492,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_3762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24707 32.4677V29.6515H10.2599V16.675C10.2599 14.2752 10.9887 12.1249 12.4463 10.224C13.9039 8.32312 15.8097 7.10023 18.1637 6.55536V5.86841C18.1637 5.20177 18.4042 4.62307 18.8852 4.13232C19.3661 3.6416 19.9502 3.39624 20.6373 3.39624C21.3244 3.39624 21.908 3.6416 22.388 4.13232C22.8681 4.62307 23.1081 5.20177 23.1081 5.86841V6.5607C25.4621 7.102 27.3748 8.31664 28.8463 10.2046C30.3178 12.0926 31.0536 14.2494 31.0536 16.675V29.6515H34.0664V32.4677H7.24707ZM20.6316 37.4805C19.7102 37.4805 18.9229 37.1529 18.2697 36.4976C17.6164 35.8423 17.2898 35.0546 17.2898 34.1344H23.982C23.982 35.0674 23.654 35.8584 22.9978 36.5072C22.3417 37.1561 21.553 37.4805 20.6316 37.4805ZM13.0761 29.6516H28.2374V16.675C28.2374 14.5824 27.4925 12.7993 26.0028 11.3257C24.513 9.85202 22.723 9.1152 20.6326 9.1152C18.5422 9.1152 16.7602 9.85202 15.2865 11.3257C13.8129 12.7993 13.0761 14.5824 13.0761 16.675V29.6516Z",
    fill: "#F2F4F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivenotifications);
export default __webpack_public_path__ + "static/media/Inactivenotifications.c702ee54d7740a8c9703775e2e36798d.svg";
export { ForwardRef as ReactComponent };